export default "__VITE_ASSET__DBLZALxD__"